import { combineReducers } from "redux";

import home from "./Home/home.reducer";
import iframe from './Iframe/iframe.reducer';
import gameUserProfile from './GameUserProfile/gameUserProfile.reducer';
import  gameUserLogin from  './GameUserLogin/gameUserLogin.reducer'
import  lifeStone from  './LifeStone/lifeStone.reducer'
import  group from  './Group/group.reducer'
import  chat from  './Chat/chat.reducer'
import  store from  './Store/store.reducer'
import  leaderboard from  './Leaderboard/leaderboard.reducer'
import  offerwall from  './OfferWall/offerwall.reducer'

const reducers = combineReducers({

    home,
    iframe,
    gameUserProfile,
    gameUserLogin,
    lifeStone,
    group,
    chat,
    store,
    leaderboard,
    offerwall
});

export default reducers;
